var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import DOMEvents from './events';
import LoadScript from '../scriptLoader';
var DOMHTML = /** @class */ (function (_super) {
    __extends(DOMHTML, _super);
    function DOMHTML() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DOMHTML.prototype.insertHTML = function (where, node, to) {
        if (to === void 0) { to = document.body; }
        var nodeElement;
        if (typeof node === 'string') {
            nodeElement = this.htmlToElement(node);
        }
        else {
            nodeElement = node;
        }
        return to.insertAdjacentElement(where, nodeElement);
    };
    DOMHTML.prototype.htmlToElement = function (html) {
        var template = document.createElement('template');
        html = html.trim();
        template.innerHTML = html;
        return template.content.firstElementChild;
    };
    DOMHTML.prototype.replaceElement = function (element, newElement) {
        var newElementTag;
        if (typeof newElement === 'string') {
            newElementTag = this.htmlToElement(newElement);
        }
        else {
            newElementTag = newElement;
        }
        var scripts = newElementTag.querySelectorAll('script');
        element.parentNode.replaceChild(newElementTag, element);
        if (scripts) {
            new LoadScript(scripts).generateScripts();
        }
        return newElementTag;
    };
    return DOMHTML;
}(DOMEvents));
export default DOMHTML;
//# sourceMappingURL=html.js.map